import request from '@/utils/request';

export function optimizationAPI() {
  return {
    // 列表
    optimizationList: params => {
      return request({
        url: '/admin/auth/optimizer/index',
        method: 'get',
        params,
      });
    },
    // 小程序名称列表
    applicationList: params => {
      return request({
        url: '/admin/microapp/index',
        method: 'get',
        params,
      });
    },
    //新增
    newlyAdded: data => {
      return request({
        url: '/admin/auth/optimizer/update',
        method: 'post',
        data
      });
    },
    //新增
    newlyAdd: data => {
      return request({
        url: '/admin/auth/optimizer/store',
        method: 'post',
        data
      });
    },
      // 详情数据
      detailsList: params => {
        return request({
          url: `/admin/auth/optimizer/show?id=${params}`,
          method: 'get',
        });
      },
  };
}
